<script setup lang="ts">
// Formkit schema: https://formkit.com/api-reference/formkit-inputs#formkitschemaextendablesection
import type { UmbracoFormField } from 'types/blocks';

const { getDefaultFormField } = useForm();

defineProps<{
  field: UmbracoFormField;
}>();
</script>

<template>
  <FormKit
    type="tel"
    v-bind="getDefaultFormField(field)"
    :validation-messages="{
      required: field.requiredErrorMessage || $t('FormMessages.General.Required'),
    }"
    :validation="field.required ? 'required' : ''"
  />
</template>
